module.exports = __webpack_public_path__ + "img/hm.54e6d58c.svg";